import { alpha, Card, CardContent, Typography, useTheme } from '@mui/material'
import { ReactNode } from 'react'

interface CardProps {
  icon?: ReactNode
  label: string
  middleLabel?: string
  selected: boolean
  onClick: () => void
  showUnselectButton?: boolean
  disabled?: boolean
}

function SelectableCard({ icon, label, middleLabel, selected, disabled, onClick }: CardProps) {
  const theme = useTheme()

  return (
    <Card
      variant="outlined"
      sx={{
        position: 'relative',
        borderRadius: '8px',
        height: '100%',
        borderWidth: 2,
        borderColor: disabled ? 'background.paper' : selected ? theme.palette.primary.main : theme.palette.primary.light,
        bgcolor: disabled ? 'background.paper' : alpha(theme.palette.primary.light, 0.25),
        transition: 'all 200ms ease-in',
        '&:hover': {
          borderColor: disabled ? 'background.paper' : 'primary.main',
        },
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={disabled ? () => {} : onClick}
    >
      <CardContent
        sx={{
          height: '100%',
          bgcolor: selected ? alpha(theme.palette.primary.light, 0.4) : 'transparent',
          textAlign: 'center',
          p: 2,
          '&:last-child': {
            pb: 2,
          },
        }}
      >
        {icon}
        <Typography variant={'subtitle1'} color={disabled ? 'text.disabled' : 'text.primary'}>
          {middleLabel}
        </Typography>
        <Typography variant={'body2'} color={disabled ? 'text.disabled' : 'text.primary'}>
          {label}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default SelectableCard
